import React from 'react';

const Teorija = () => (
    <section className="section container has-text-centered">
        <div className="columns is-centered">
            <div className="table">
                <table className="table is-bordered is-hoverable">
                    <thead>
                        <tr>
                            <th><strong>Multiplying Factor</strong></th>
                            <th><strong>SI Prefix</strong></th>
                            <th class="alignCenter"><strong>Scientific Notation</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1 000 000 000 000 000 000 000 000</td>
                            <td>yotta (Y)</td>
                            <td class="alignCenter">10<sup>24</sup></td>
                        </tr>
                        <tr>
                            <td>1 000 000 000 000 000 000 000</td>
                            <td>zetta (Z)</td>
                            <td class="alignCenter">10<sup>21</sup></td>
                        </tr>
                        <tr>
                            <td>1 000 000 000 000 000 000</td>
                            <td>exa (E)</td>
                            <td class="alignCenter">10<sup>18</sup></td>
                        </tr>
                        <tr>
                            <td>1 000 000 000 000 000</td>
                            <td>peta (P)</td>
                            <td class="alignCenter">10<sup>15</sup></td>
                        </tr>
                        <tr>
                            <td>1 000 000 000 000</td>
                            <td>tera (T)</td>
                            <td class="alignCenter">10<sup>12</sup></td>
                        </tr>
                        <tr>
                            <td>1 000 000 000</td>
                            <td>giga (G)</td>
                            <td class="alignCenter">10<sup>9</sup></td>
                        </tr>
                        <tr>
                            <td>1 000 000</td>
                            <td>mega (M)</td>
                            <td class="alignCenter">10<sup>6</sup></td>
                        </tr>
                        <tr>
                            <td>1 000</td>
                            <td>kilo (k)</td>
                            <td class="alignCenter">10<sup>3</sup></td>
                        </tr>
                        <tr>
                            <td>100</td>
                            <td>hecto (h)</td>
                            <td class="alignCenter">10<sup>2</sup></td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>deca (da)</td>
                            <td class="alignCenter">10<sup>1</sup></td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>&nbsp;</td>
                            <td class="alignCenter">10<sup>0</sup></td>
                        </tr>
                        <tr>
                            <td>0.1</td>
                            <td>deci (d)</td>
                            <td class="alignCenter">10<sup>-1</sup></td>
                        </tr>
                        <tr>
                            <td>0.01</td>
                            <td>centi (c)</td>
                            <td class="alignCenter">10<sup>-2</sup></td>
                        </tr>
                        <tr>
                            <td>0.001</td>
                            <td>milli (m)</td>
                            <td class="alignCenter">10<sup>-3</sup></td>
                        </tr>
                        <tr>
                            <td>0.000 001</td>
                            <td>micro (<i>&micro;</i>)</td>
                            <td class="alignCenter">10<sup>-6</sup></td>
                        </tr>
                        <tr>
                            <td>0.000 000 001</td>
                            <td>nano (n)</td>
                            <td class="alignCenter">10<sup>-9</sup></td>
                        </tr>
                        <tr>
                            <td>0.000 000 000 001</td>
                            <td>pico (p)</td>
                            <td class="alignCenter">10<sup>-12</sup></td>
                        </tr>
                        <tr>
                            <td>0.000 000 000 000 001</td>
                            <td>femto (f)</td>
                            <td class="alignCenter">10<sup>-15</sup></td>
                        </tr>
                        <tr>
                            <td>0.000 000 000 000 000 001</td>
                            <td>atto (a)</td>
                            <td class="alignCenter">10<sup>-18</sup></td>
                        </tr>
                        <tr>
                            <td>0.000 000 000 000 000 000 001</td>
                            <td>zepto (z)</td>
                            <td class="alignCenter">10<sup>-21</sup></td>
                        </tr>
                        <tr>
                            <td>0.000 000 000 000 000 000 000 001</td>
                            <td>yocto (y)</td>
                            <td class="alignCenter">10<sup>-24</sup></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
)

export default Teorija;
